/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:0bc4f09d-c212-4ae3-bd04-9978dff2d292",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_jShFHmcIP",
    "aws_user_pools_web_client_id": "3uiqbcb04ctnoe4mr3m8t64f5d",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://vhmmbsomgvcvvmb5dlp4jteaae.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-tbzj3nd3g5gvhprtzpwt7ot4em",
    "aws_cloud_logic_custom": [
        {
            "name": "lighticowebhooks",
            "endpoint": "https://4m4zz5mlq0.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
